/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ names: NonNullable<unknown> }} Workout_Share_Analysis_RecordsInputs */

const en_us2_workout_share_analysis_records = /** @type {(inputs: Workout_Share_Analysis_RecordsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`a record on ${i?.names}`)
};

const pt_br2_workout_share_analysis_records = /** @type {(inputs: Workout_Share_Analysis_RecordsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`recorde em ${i?.names}`)
};

const es_419_workout_share_analysis_records = /** @type {(inputs: Workout_Share_Analysis_RecordsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`récord en ${i?.names}`)
};

const pt_pt2_workout_share_analysis_records = /** @type {(inputs: Workout_Share_Analysis_RecordsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`recorde em ${i?.names}`)
};

const fr_fr2_workout_share_analysis_records = /** @type {(inputs: Workout_Share_Analysis_RecordsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`un record sur ${i?.names}`)
};

const de_de2_workout_share_analysis_records = /** @type {(inputs: Workout_Share_Analysis_RecordsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ein Rekord bei ${i?.names}`)
};

const it_it2_workout_share_analysis_records = /** @type {(inputs: Workout_Share_Analysis_RecordsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`record su ${i?.names}`)
};

/**
* | output |
* | --- |
* | "a record on {names}" |
*
* @param {Workout_Share_Analysis_RecordsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_share_analysis_records = /** @type {((inputs: Workout_Share_Analysis_RecordsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Share_Analysis_RecordsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_share_analysis_records(inputs)
	if (locale === "es-419") return es_419_workout_share_analysis_records(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_share_analysis_records(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_share_analysis_records(inputs)
	if (locale === "de-DE") return de_de2_workout_share_analysis_records(inputs)
	if (locale === "it-IT") return it_it2_workout_share_analysis_records(inputs)
	return en_us2_workout_share_analysis_records(inputs)
});
export { workout_share_analysis_records as "workout-share.analysis_records" }